"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing", className, styles.root),
        appDetails: styling_1.mergeStyles("listing-app-details", styles.appDetails),
        metadata: styling_1.mergeStyles("listing-metadata", styles.metadata),
        metadataSection: styling_1.mergeStyles("listing-metadata-section", styles.metadataSection),
        metadataSectionTitle: styling_1.mergeStyles("listing-metadata-section-title", styles.metadataSectionTitle),
        metadataSectionContent: styling_1.mergeStyles("listing-metadata-section-title", styles.metadataSectionContent),
        content: styling_1.mergeStyles("listing-content", styles.content),
        detailContent: styling_1.mergeStyles("listing-detail-content", styles.detailContent),
        detailTabs: styling_1.mergeStyles("listing-detail-tabs", styles.detailTabs),
        summary: styling_1.mergeStyles("listing-summary", styles.summary),
        title: styling_1.mergeStyles("listing-title", styles.title),
        shortDescription: styling_1.mergeStyles("listing-short-description", styles.shortDescription),
        actions: styling_1.mergeStyles("listing-actions", styles.actions),
        description: styling_1.mergeStyles("listing-description", styles.description),
        banner: styling_1.mergeStyles("listing-banner", styles.banner),
        rating: styling_1.mergeStyles("listing-rating", styles.rating),
        reviewCount: styling_1.mergeStyles("listing-review-count", styles.reviewCount)
    };
});
exports.getClassNames = getClassNames;
